import Vue from 'vue'
import VueRouter from 'vue-router'
import cognitoAuth from '@/plugins/cognito'
import Layout from '@/components/Layout'
import KnowledgeBaseViewer from '@/components/KnowledgeBaseViewer'
import CategoryViewer from '@/components/CategoryViewer'
import Unauthed from '@/components/Unauthed'
import Selector from '@/components/Selector'


Vue.use(VueRouter)

function requireAuth(to, from, next) {
  console.log("requireAuth")
  cognitoAuth.isAuthenticated((err, loggedIn) => {
    console.log("got auth response: ", loggedIn)
    if (err){
      console.log("received error from auth check", err)
      //return next()
    } 
    if (!loggedIn) {
      console.log("Not authed, err:", err);
      next({
        path: '/unauthed'
      })
    } else {
      console.log("logged in")
      next()
    }
  })
}

/*
function checker(to, from, next) {
  var request = new XMLHttpRequest();
  request.open('GET', window.location.href, false);  // `false` makes the request synchronous
  request.send(null);

  if (request.status === 200) {
    console.log("response headers:", request.getAllResponseHeaders());
    let holdHeader = request.getResponseHeader("x-kb-id-l");
    if (holdHeader == undefined) {
      next({
        path: '/kb/v/a4265b4a-80ac-4f6a-9051-09db5b243399',
        query: { redirect: to.fullPath }
      })
    } else {
      next({
        path: `/kb/v/${holdHeader}`,
        query: { redirect: to.fullPath }
      })
    }

  }
}
*/


export default new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  //base: __dirname,
  base: process.env.NODE_ENV === 'production'
    ? '/kbs'
    : '/kbs',
  routes: [
    { path: '/', component: Layout, beforeEnter: requireAuth },
    { path: '/kb', component: Layout, beforeEnter: requireAuth },
    // dynamic segments start with a colon
    { path: '/v/:kb_id/:category_id/:content_id', component: CategoryViewer },
    { path: '/v/:kb_id/:category_id/:content_id/:standalone', component: CategoryViewer },
    { path: '/kb/:id', component: Layout, beforeEnter: requireAuth },
    { path: '/kb/v/:id', component: KnowledgeBaseViewer },
    { path: '/unauthed', component: Unauthed },
    { path: '/selector', component: Selector },
    //{ path: '/kb/vh', component: KnowledgeBaseViewer }, //get the id from cdn origin request header
    //{ path: '/kb', component: Layout },
  ]

})
